import { config } from 'api';
import { Url } from 'lib/utils/url';

export function getTagsAndFilters(tags, filters) {
  let resultTags = [];
  if (tags) resultTags = resultTags.concat(tags);
  if (filters) resultTags = resultTags.concat(filters.split(','));
  return resultTags.join(',');
}

// eslint-disable-next-line complexity
export function buildApiQuery(tags, query, state) {
  const {
    campaigns,
    sort,
    filters,
    customFilters,
    price,
    hideOOS,
    showOOS,
    entry,
    clusterPath,
    showAllFavourites,
  } = query;
  const hasHideOOSBetaFeature = state && state.user.betaFeatures.includes('HIDE_OOS_ITEMS');
  const queryParams = {
    ...(hasHideOOSBetaFeature && { hideOOS: !showOOS }),
  };

  if (entry) {
    queryParams.searchTerm = entry;
  }
  if (showAllFavourites) {
    queryParams.showAllFavourites = showAllFavourites;
  }
  if (clusterPath) {
    queryParams.clusterPath = clusterPath;
  }
  if (tags || filters) {
    queryParams.tags = getTagsAndFilters(tags, filters);
  }
  if (customFilters) {
    queryParams.customFilters = customFilters;
  }
  if (price) {
    queryParams.priceFilters = price;
  }
  if (sort) {
    queryParams.sort = sort;
  }
  if (!hasHideOOSBetaFeature && hideOOS) {
    queryParams.hideOOS = hideOOS;
  }
  if (campaigns) {
    queryParams.campaigns = campaigns;
  }

  return queryParams;
}

export function buildApiUrl(apiPath, apiQuery = {}) {
  return new Url(`${config.apiBasePath}${apiPath}`)
    .addQueryParameters(apiQuery)
    .filterQueryParameters((key, value) => value || value === false || value === 0)
    .toString();
}

export function getProductsPageApiUrl(productsPageRoute, buildApiUrlHelper, state) {
  const { basePath, deslugifiedParams, deslugifiedQuery } = productsPageRoute;
  const { tags } = deslugifiedParams;
  switch (basePath) {
    case '/search': {
      return buildApiUrl(
        '/search',
        buildApiQuery(tags, deslugifiedQuery, state)
      );
    }
    case '/browse': {
      return buildApiUrl(
        '/browse',
        buildApiQuery(tags, deslugifiedQuery, state)
      );
    }
    case '/on-offer': {
      return buildApiUrl(
        '/on-offer',
        buildApiQuery(tags, deslugifiedQuery, state)
      );
    }
    case '/offers': {
      return buildApiUrl(
        `/offers/${deslugifiedParams.id}`,
        { sort: deslugifiedQuery.sort },
      );
    }
    case '/your-savings-hub': {
      return buildApiUrl(
        '/your-savings-hub',
        buildApiQuery(tags, deslugifiedQuery, state)
      );
    }
    case '/coupons':
    case '/coupons/products': {
      const baseUrl = '/coupons/fops';
      if (typeof buildApiUrlHelper === 'function') {
        return buildApiUrl(...buildApiUrlHelper(
          baseUrl,
          buildApiQuery(tags, deslugifiedQuery)
        ));
      }
      return buildApiUrl(
        baseUrl,
        buildApiQuery(tags, deslugifiedQuery)
      );
    }
    default: {
      throw new Error(`Unsupported route ${basePath}`);
    }
  }
}

export function getRecommendedProductsApiUrl(productsPageRoute) {
  const { basePath, deslugifiedParams, deslugifiedQuery } = productsPageRoute;
  const { tags } = deslugifiedParams;
  switch (basePath) {
    case '/search': {
      return buildApiUrl(
        '/search/recommendations',
        buildApiQuery(tags, deslugifiedQuery)
      );
    }
    case '/browse': {
      return buildApiUrl(
        '/browse/recommendations',
        buildApiQuery(tags, deslugifiedQuery)
      );
    }
    case '/on-offer': {
      return buildApiUrl(
        '/on-offer/recommendations',
        buildApiQuery(tags, deslugifiedQuery)
      );
    }
    case '/offers': {
      return buildApiUrl(
        `/offers/${deslugifiedParams.id}/recommendations`
      );
    }
    default: {
      throw new Error(`Unsupported route ${basePath}`);
    }
  }
}
